import { User, Mail } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';

import { useSelf } from '@/data/user';

const CustomerDisplay = () => {
  const self = useSelf();

  if (self.isLoading && !self.data) {
    return null;
  }

  if (!self.data) {
    return null;
  }

  return (
    <Card className="w-full max-w-md hover:shadow-md transition-shadow">
      <CardContent className="pt-6">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-4">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted">
              <User className="h-6 w-6 text-muted-foreground" />
            </div>
            <div>
              <h3 className="font-medium">
                {self.data.firstname} {self.data.lastname}
              </h3>
              <div className="flex items-center text-sm text-muted-foreground">
                <Mail className="mr-1 h-3.5 w-3.5" />
                {self.data.email}
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomerDisplay;
